import type { SxProps, Theme } from '@mui/material'

export const styles = {
  fadeGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.25,
  },
} satisfies Record<string, SxProps<Theme>>
